import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export const ConfirmModal = ({ isOpen, title, message, onCancel, onConfirm }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && isOpen) onCancel();
    };

    window.addEventListener('keydown', onKey);

    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className='modal-backdrop-blur'
         tabIndex='-1'
         role='dialog'
         aria-modal='true'
         aria-labelledby='confirm-modal-title'
         aria-hidden='true'
         style={{ zIndex: 1060 }}
    >
      <div className='text-left modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable'
           role='document'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title' id='exampleModalCenterTitle'>{title}</h5>

            <button type='button' className='close' aria-label='Close' onClick={onCancel}>
              <span aria-hidden='true'>&times;</span>
            </button>
          </div>

          <div className='modal-body'>
            {message}
          </div>

          <div className='modal-footer d-flex'>
            <button type='button' className='btn btn-secondary' onClick={onCancel}>
              { __('app.cancel') }
            </button>

            <button type='button' className='btn btn-success' onClick={onConfirm}>
              { __('app.submit') }
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

ConfirmModal.defaultProps = {
  title: 'Potwierdzenie',
  message: 'Czy na pewno chcesz wykonać tę akcję?',
};
